import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthProvider";

export default function FullPageLoader() {
  const { loading: isLoading } = useAuth();

  return (
    isLoading && (
      <div className="relative min-h-screen">
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-linear-to-br from-blue-600 to-purple-700"  style={{ zIndex: 9999 }}>
          <div className="text-center">
            <Loader2 className="w-16 h-16 text-white animate-spin mx-auto mb-4" />
            <p className="text-white text-xl font-semibold">Loading...</p>
            <p className="text-blue-100 text-sm mt-2">
              Please wait while we prepare everything
            </p>
          </div>
        </div>
      </div>
    )
  );
}
